import { Button, Search, Checkbox } from '@usitsdasdesign/dds-react';
import Text from 'atoms/Text';
import SearchableSelect from 'molecules/SearchableSelect';
import { useMemo, useRef } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { RenderDelegates } from './RenderDelegates';

function AddDelegate({
    control,
    register,
    valueChanged,
    accessOptions,
    searchResults = { rows: [], count: 0 },
    watch,
    setValue,
    updateResources,
    isEdit
}) {
    const toMap = useMemo(
        () => (Object.keys(watch('selected') ?? {}).length > 0 ? [watch('selected')] : searchResults?.rows ?? []),
        [searchResults, watch('selected')]
    );
    const isSelected = Object.keys(watch('selected') ?? {}).length > 0;
    return (
        <div>
            {
                !isSelected && (
                    <>
                        <Text variant='label' className='mb-1' color='text-gray-1100'>Choose a resource to give access </Text>
                        <Search
                            icon="search__s__stroke"
                            placeholder="Search for a resource"
                            size="l"
                            valueChanged={valueChanged}
                        />
                    </>
                )
            }
            <div className='mb-4 overflow-auto max-h-[65vh]' >
                {
                    toMap.map((row, i) => (
                        <RenderDelegates
                            row={row}
                            isEdit={isEdit}
                            key={i}
                            isDelegated={false}
                            isSelected={isSelected}
                            onSelect={() => {
                                isSelected ? setValue('selected', {}) : setValue('selected', row);
                            }}
                        />
                    ))
                }
                {!isSelected && <div className='mt-4 flex items-center flex-col'>
                    {(searchResults?.rows?.length < searchResults?.count) && <Button
                        label='Load More'
                        size='m'
                        onClick={updateResources}
                    />}
                </div>
                }
            </div>
            {
                isSelected && (
                    <>
                        <SearchableSelect
                            control={control}
                            register={register}
                            name='access'
                            label='Select access'
                            options={accessOptions}
                            placeholder='Select access'
                            isMulti={false}
                        />

                        {
                            (watch('access') && watch('access')?.value && watch('access')?.value === 'project') ? (
                                <div className="mt-4">
                                    <Checkbox
                                        register={register}
                                        value={watch("delegateAllIntakeRequests")}
                                        name="delegateAllIntakeRequests"
                                        label="Delegate all intake requests"
                                        showLabel
                                        onChangeHandler={(data) => {
                                            setValue('delegateAllIntakeRequests', data.value, { shouldValidate: true });
                                        }}
                                    />
                                </div>
                            ) : null
                        }
                    </>
                )
            }

        </div>
    );
}

export default AddDelegate;
